export const INFO_FIELDS = [
  { key: "startAt", label: "Start At", type: 'date'},
  { key: "endAt", label: "End At", type: 'date'},
  { key: "last_paid", label: "Last Paid", type: 'date'},
];

export const CAR_INFO_FIELDS = [
  { key: "license_plate", label: "License Plate"},
  { key: "brand", label: "Brand"},
  { key: "type", label: "Type"},
  { key: "year_build", label: "Year Build"},
  { key: "seats_number", label: "Seats Number"},
  { key: "tow_bar", label: "Tow Bar", type: 'boolean'},
  { key: "tax", label: "Tax", type: 'price'},
];

export const ROOM_INFO_FIELDS = [
  { key: "room_number", label: "Room Number"},
  { key: "snf_certified", label: "SNF Certified"},
  { key: "max_persons", label: "Max People"},
  { key: "capacity", label: "Reservations"},
  { key: "target_price", label: "Target Price", type: 'price'},
  { key: "housing", label: "Housing", nested: [
    { key: "street_name", label: "Street Name"},
    { key: "number", label: "Street Number"},
    { key: "city", label: "City"},
    { key: "postal_code", label: "Postal Code"},
  ]},
];
